<template class="mr-3">
  <div class="card">
    <div class="card-body">
      <div>
        <a-button
          type="file-pdf"
          @click="generatePdf"
          style="margin-bottom: 20px; float: right"
        >
          <a-icon type="file-pdf" @click="generatePdf" />
          {{ $t("action.imprimerTab") }}
        </a-button>
        <a-button type="user-add" @click="showModal">
          <a-icon type="user-add" @click="showModal" />
          {{ $t("action.ajouter") }}
          {{ $t("menu.personnel") }}
        </a-button>
        <div>
          <a-modal
            v-model="visibleData"
            @cancel="handleCancel"
            :width="980"
            :title="$t('all.enterInformationBelow')"
            :footer="false"
          >
            <a-form :form="form" class="container" @submit="addPersonnel">
              <fieldset>
                <legend>{{ $t("personnel.infoBase") }}:</legend>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.nom')">
                      <a-input
                        :placeholder="$t('profil.nom')"
                        v-decorator="[
                          'lastName',
                          {
                            rules: [
                              {
                                required: true,
                                message: $t('requis.nom'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.prenom')">
                      <a-input
                        :placeholder="$t('profil.prenom')"
                        v-decorator="[
                          'firstName',
                          {
                            rules: [
                              {
                                required: true,
                                message: $t('requis.prenomPere'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.middleName')">
                      <a-input
                        :placeholder="$t('profil.middleName')"
                        v-decorator="['middleName']"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.dateNaissance')">
                      <a-date-picker
                        v-decorator="['birthDate']"
                        :placeholder="$t('all.selectDate')"
                        :format="dateFormat"
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="isKenyan ? $t('personnel.idCard') : $t('personnel.cin')">
                      <a-input
                        :placeholder="isKenyan ? $t('personnel.idCard') : $t('personnel.cin')"
                        type="string"
                        v-decorator="[
                          'cin',
                          {
                            rules: isKenyan ? [] : [
                              {
                                pattern: /^[0-1][0-9]{7}$/,
                                message: $t('requis.cin01'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.adresse')">
                      <a-input
                        :placeholder="$t('profil.adresse')"
                        v-decorator="['adress']"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('liste.telephone')">
                      <phone-number-input
                        :default-country-code="isKenyan ? 'KE' : 'TN'"
                        v-decorator="[
                          'phone',
                          {
                            rules: [
                              {
                                required: true,
                                message: $t('requis.phoneRequired'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4" v-if="!isKenyan">
                    <a-form-item :label="$t('personnel.etatCivil')">
                      <a-input
                        :placeholder="$t('personnel.etatCivil')"
                        v-decorator="['civilStatus']"
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ isKenyan ? $t("personnel.qualifications") : $t("personnel.niveau") }}:</legend>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="isKenyan ? $t('personnel.qualifications') : $t('personnel.niveau')">
                      <a-input
                        :placeholder="isKenyan ? $t('personnel.qualifications') : $t('personnel.niveau')"
                        v-decorator="['level']"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-8">
                    <a-form-item :label="$t('personnel.experiences')">
                      <a-input
                        :placeholder="$t('personnel.experiences')"
                        type="textarea"
                        v-decorator="[
                          'experiences',
                          {
                            rules: [
                              {
                                required: false,
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ $t("personnel.infoContrat") }}</legend>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.qualification')">
                      <a-select
                        v-decorator="[
                          'position',
                          {
                            rules: [
                              {
                                required: true,
                                message: $t('requis.qualification'),
                              },
                            ],
                          },
                        ]"
                        show-search
                        :allowClear="true"
                        :placeholder="$t('personnel.qualification')"
                        style="width: 100%"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        :getPopupContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      >
                        <a-select-option
                          v-for="position in positionsList"
                          :key="position._id"
                          :value="position._id"
                          >{{ position.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.typeContrat')">
                      <a-input
                        :placeholder="$t('personnel.typeContrat')"
                        v-decorator="['contract']"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.salaire') + ' (net)'">
                      <a-input
                        :placeholder="$t('personnel.salaire') + ' (net)'"
                        type="number"
                        v-decorator="['salary.net']"
                      />
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.dateEntretien')">
                      <a-date-picker
                        v-decorator="['interviewDate']"
                        :placeholder="$t('all.selectDate')"
                        :format="dateFormat"
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('all.startDate')">
                      <a-date-picker
                        v-decorator="['StartDate']"
                        :placeholder="$t('all.selectDate')"
                        :format="dateFormat"
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('all.endDate')">
                      <a-date-picker
                        v-decorator="['endDate']"
                        :placeholder="$t('all.selectDate')"
                        :format="dateFormat"
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ $t("personnel.detailPaiement") }}</legend>
                <div class="row">
                  <div class="col-md-3" v-if="!isKenyan">
                    <a-form-item :label="$t('personnel.tauxHoraire')">
                      <a-input
                        :placeholder="$t('personnel.tauxHoraire')"
                        type="number"
                        v-decorator="[
                          'hourlyRate',
                          {
                            initialValue: 0,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3">
                    <a-form-item :label="$t('personnel.jourSemaine')">
                      <a-input
                        :placeholder="$t('personnel.jourSemaine')"
                        type="number"
                        v-decorator="[
                          'dayOfWeek',
                          {
                            initialValue: 0,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3">
                    <a-form-item :label="$t('personnel.expectedHoursPerDay')">
                      <a-input
                        :placeholder="$t('personnel.expectedHoursPerDay')"
                        type="number"
                        step="0.5"
                        v-decorator="[
                          'expectedHoursPerDay',
                          { initialValue: null },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3">
                    <a-form-item :label="$t('personnel.daysOff')">
                      <a-select
                        mode="multiple"
                        style="width: 100%"
                        :placeholder="$t('personnel.daysOffPlaceholder')"
                        v-decorator="['daysOff', { initialValue: [] }]"
                      >
                        <a-select-option :value="0">{{ $t("personnel.weekday_0") }}</a-select-option>
                        <a-select-option :value="1">{{ $t("personnel.weekday_1") }}</a-select-option>
                        <a-select-option :value="2">{{ $t("personnel.weekday_2") }}</a-select-option>
                        <a-select-option :value="3">{{ $t("personnel.weekday_3") }}</a-select-option>
                        <a-select-option :value="4">{{ $t("personnel.weekday_4") }}</a-select-option>
                        <a-select-option :value="5">{{ $t("personnel.weekday_5") }}</a-select-option>
                        <a-select-option :value="6">{{ $t("personnel.weekday_6") }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                  <div class="col-md-3">
                    <a-form-item :label="isKenyan ? $t('personnel.sha') : $t('personnel.cnss')">
                      <a-input
                        :placeholder="isKenyan ? $t('personnel.sha') : $t('personnel.cnss')"
                        v-decorator="[isKenyan ? 'SHA' : 'CNSS', { initialValue: isKenyan ? '' : 0 }]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3" v-if="isKenyan">
                    <a-form-item :label="$t('personnel.nssf')">
                      <a-input
                        :placeholder="$t('personnel.nssf')"
                        v-decorator="['NSSF', { initialValue: '' }]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3" v-if="isKenyan">
                    <a-form-item :label="$t('personnel.pin')">
                      <a-input
                        :placeholder="$t('personnel.pin')"
                        v-decorator="['PIN', { initialValue: '' }]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3" v-if="!isKenyan">
                    <a-form-item :label="$t('personnel.rib')">
                      <a-input
                        :placeholder="$t('personnel.rib')"
                        v-decorator="['RIB', { initialValue: '0' }]"
                      />
                    </a-form-item>
                  </div>
                </div>
                <div class="row" v-if="isKenyan">
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.bankAccountNo')">
                      <a-input
                        :placeholder="$t('personnel.bankAccountNo')"
                        v-decorator="['bankAccountNo', { initialValue: '0' }]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.bankName')">
                      <a-select
                        v-decorator="['bankName']"
                        :placeholder="$t('personnel.bankName')"
                        show-search
                        :allowClear="true"
                        style="width: 100%"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        :getPopupContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      >
                        <a-select-option
                          v-for="bank in kenyanBanks"
                          :key="bank"
                          :value="bank"
                          >{{ bank }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.bankBranch')">
                      <a-input
                        :placeholder="$t('personnel.bankBranch')"
                        v-decorator="[
                          'bankBranch',
                          {
                            initialValue: '',
                            rules: [
                              {
                                pattern: /^[A-Za-z\s-]*$/,
                                message: $t('requis.alphabeticOnly'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ $t("personnel.autre") }}:</legend>
                <div class="row">
                  <a-form-item :label="$t('profil.notes')" class="col-md-12">
                    <a-input
                      :placeholder="$t('profil.notes')"
                      type="textarea"
                      v-decorator="['notes']"
                    />
                  </a-form-item>
                </div>
              </fieldset>
              <div class="form-actions mt-0 row">
                <div class="col-md-2 offset-md-8 p-0">
                  <a-button key="back" @click="handleCancel">{{
                    $t("action.annuler")
                  }}</a-button>
                </div>
                <div class="col-md-2 p-0">
                  <a-button
                    type="primary"
                    htmlType="submit"
                    :loading="loadingAddBtn"
                    :disabled="loadingAddBtn"
                    >{{ $t("action.ajouter") }}</a-button
                  >
                </div>
              </div>
            </a-form>
          </a-modal>
          <a-modal
            v-model="visibleUpdateData"
            @cancel="handleCancel"
            :width="980"
            :title="$t('all.enterInformationBelow')"
            :footer="false"
          >
            <a-form
              :form="updateForm"
              class="container"
              @submit="updatePersonnel"
            >
              <fieldset>
                <legend>{{ $t("personnel.infoBase") }}:</legend>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.prenom')">
                      <a-input
                        :placeholder="$t('profil.prenom')"
                        v-decorator="[
                          'firstName',
                          {
                            initialValue: updateData.firstName,
                            rules: [
                              {
                                required: true,
                                message: $t('requis.prenomPere'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.middleName')">
                      <a-input
                        :placeholder="$t('profil.middleName')"
                        v-decorator="[
                          'middleName',
                          {
                            initialValue: updateData.middleName,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.nom')">
                      <a-input
                        :placeholder="$t('profil.nom')"
                        v-decorator="[
                          'lastName',
                          {
                            initialValue: updateData.lastName,
                            rules: [
                              {
                                required: true,
                                message: $t('requis.nom'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.dateNaissance')">
                      <a-date-picker
                        :placeholder="$t('all.selectDate')"
                        v-decorator="[
                          'birthDate',
                          {
                            initialValue: updateData.birthDate,
                          },
                        ]"
                        :format="dateFormat"
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="isKenyan ? $t('personnel.idCard') : $t('personnel.cin')">
                      <a-input
                        :placeholder="isKenyan ? $t('personnel.idCard') : $t('personnel.cin')"
                        type="string"
                        v-decorator="[
                          'cin',
                          {
                            initialValue: updateData.cin,
                            rules: isKenyan ? [] : [
                              {
                                pattern: /^[0-1][0-9]{7}$/,
                                message: $t('requis.cin01'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('profil.adresse')">
                      <a-input
                        :placeholder="$t('profil.adresse')"
                        v-decorator="[
                          'adress',
                          {
                            initialValue: updateData.adress,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('liste.telephone')">
                      <phone-number-input
                        :default-country-code="isKenyan ? 'KE' : 'TN'"
                        v-decorator="[
                          'phone',
                          {
                            initialValue: updateData.phone,
                            rules: [
                              {
                                required: true,
                                message: $t('requis.phoneRequired'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4" v-if="!isKenyan">
                    <a-form-item :label="$t('personnel.etatCivil')">
                      <a-input
                        :placeholder="$t('personnel.etatCivil')"
                        v-decorator="[
                          'civilStatus',
                          {
                            initialValue: updateData.civilStatus,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ isKenyan ? $t("personnel.qualifications") : $t("personnel.niveau") }}:</legend>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="isKenyan ? $t('personnel.qualifications') : $t('personnel.niveau')">
                      <a-input
                        :placeholder="isKenyan ? $t('personnel.qualifications') : $t('personnel.niveau')"
                        v-decorator="[
                          'level',
                          {
                            initialValue: updateData.level,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-8">
                    <a-form-item :label="$t('personnel.experiences')">
                      <a-input
                        :placeholder="$t('personnel.experiences')"
                        type="textarea"
                        v-decorator="[
                          'experiences',
                          {
                            initialValue: updateData.experiences,
                            rules: [
                              {
                                required: false,
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ $t("personnel.infoContrat") }}:</legend>
                <div class="row">
                  <div class="col-md-4" v-if="!updateData.isA_Teacher">
                    <a-form-item :label="$t('personnel.qualification')">
                      <a-select
                        v-decorator="[
                          'position',
                          {
                            initialValue: updateData.position
                              ? updateData.position._id
                              : '',
                            rules: [
                              {
                                required: true,
                                message: $t('requis.qualification'),
                              },
                            ],
                          },
                        ]"
                        show-search
                        :allowClear="true"
                        :placeholder="$t('personnel.qualification')"
                        style="width: 100%"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        :getPopupContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      >
                        <a-select-option
                          v-for="position in positionsList"
                          :key="position._id"
                          :value="position._id"
                          >{{ position.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.typeContrat')">
                      <a-input
                        :placeholder="$t('personnel.typeContrat')"
                        v-decorator="[
                          'contract',
                          {
                            initialValue: updateData.contract,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.salaire') + ' (net)'">
                      <a-input
                        :placeholder="$t('personnel.salaire') + ' (net)'"
                        type="number"
                        v-decorator="[
                          'salary.net',
                          {
                            initialValue:
                              updateData.salary && updateData.salary.net
                                ? updateData.salary.net
                                : null,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.dateEntretien')">
                      <a-date-picker
                        :placeholder="$t('all.selectDate')"
                        v-decorator="[
                          'interviewDate',
                          {
                            initialValue: updateData.interviewDate,
                          },
                        ]"
                        :format="dateFormat"
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('all.startDate')">
                      <a-date-picker
                        :placeholder="$t('all.selectDate')"
                        v-decorator="[
                          'StartDate',
                          {
                            initialValue: updateData.StartDate,
                          },
                        ]"
                        :format="dateFormat"
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('all.endDate')">
                      <a-date-picker
                        :placeholder="$t('all.selectDate')"
                        v-decorator="[
                          'endDate',
                          {
                            initialValue: updateData.endDate
                              ? updateData.endDate
                              : null,
                          },
                        ]"
                        :format="dateFormat"
                        :getCalendarContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ $t("personnel.detailPaiement") }}:</legend>
                <div class="row">
                  <div class="col-md-3" v-if="!isKenyan">
                    <a-form-item :label="$t('personnel.tauxHoraire')">
                      <a-input
                        :placeholder="$t('personnel.tauxHoraire')"
                        type="number"
                        v-decorator="[
                          'hourlyRate',
                          {
                            initialValue: updateData.hourlyRate,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3">
                    <a-form-item :label="$t('personnel.jourSemaine')">
                      <a-input
                        :placeholder="$t('personnel.jourSemaine')"
                        type="number"
                        v-decorator="[
                          'dayOfWeek',
                          {
                            initialValue: updateData.dayOfWeek,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3">
                    <a-form-item :label="$t('personnel.expectedHoursPerDay')">
                      <a-input
                        :placeholder="$t('personnel.expectedHoursPerDay')"
                        type="number"
                        step="0.5"
                        v-decorator="[
                          'expectedHoursPerDay',
                          {
                            initialValue: updateData.expectedHoursPerDay,
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3">
                    <a-form-item :label="$t('personnel.daysOff')">
                      <a-select
                        mode="multiple"
                        style="width: 100%"
                        :placeholder="$t('personnel.daysOffPlaceholder')"
                        v-decorator="[
                          'daysOff',
                          {
                            initialValue: updateData.daysOff || [],
                          },
                        ]"
                      >
                        <a-select-option :value="0">{{ $t("personnel.weekday_0") }}</a-select-option>
                        <a-select-option :value="1">{{ $t("personnel.weekday_1") }}</a-select-option>
                        <a-select-option :value="2">{{ $t("personnel.weekday_2") }}</a-select-option>
                        <a-select-option :value="3">{{ $t("personnel.weekday_3") }}</a-select-option>
                        <a-select-option :value="4">{{ $t("personnel.weekday_4") }}</a-select-option>
                        <a-select-option :value="5">{{ $t("personnel.weekday_5") }}</a-select-option>
                        <a-select-option :value="6">{{ $t("personnel.weekday_6") }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                  <div class="col-md-3">
                    <a-form-item :label="isKenyan ? $t('personnel.sha') : $t('personnel.cnss')">
                      <a-input
                        :placeholder="isKenyan ? $t('personnel.sha') : $t('personnel.cnss')"
                        v-decorator="[
                          isKenyan ? 'SHA' : 'CNSS',
                          { initialValue: isKenyan ? updateData.SHA : updateData.CNSS }
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3" v-if="isKenyan">
                    <a-form-item :label="$t('personnel.nssf')">
                      <a-input
                        :placeholder="$t('personnel.nssf')"
                        v-decorator="['NSSF', { initialValue: updateData.NSSF }]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3" v-if="isKenyan">
                    <a-form-item :label="$t('personnel.pin')">
                      <a-input
                        :placeholder="$t('personnel.pin')"
                        v-decorator="['PIN', { initialValue: updateData.PIN }]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-3" v-if="!isKenyan">
                    <a-form-item :label="$t('personnel.rib')">
                      <a-input
                        :placeholder="$t('personnel.rib')"
                        v-decorator="[
                          'RIB',
                          { initialValue: updateData.RIB }
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
                <div class="row" v-if="isKenyan">
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.bankAccountNo')">
                      <a-input
                        :placeholder="$t('personnel.bankAccountNo')"
                        v-decorator="[
                          'bankAccountNo',
                          { initialValue: updateData.bankAccountNo || '' }
                        ]"
                      />
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.bankName')">
                      <a-select
                        v-decorator="[
                          'bankName',
                          {
                            initialValue: updateData.bankName || undefined,
                          },
                        ]"
                        :placeholder="$t('personnel.bankName')"
                        show-search
                        :allowClear="true"
                        style="width: 100%"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        :getPopupContainer="
                          (triggerNode) => triggerNode.parentNode
                        "
                      >
                        <a-select-option
                          v-for="bank in kenyanBanks"
                          :key="bank"
                          :value="bank"
                          >{{ bank }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </div>
                  <div class="col-md-4">
                    <a-form-item :label="$t('personnel.bankBranch')">
                      <a-input
                        :placeholder="$t('personnel.bankBranch')"
                        v-decorator="[
                          'bankBranch',
                          {
                            initialValue: updateData.bankBranch || '',
                            rules: [
                              {
                                pattern: /^[A-Za-z\s-]*$/,
                                message: $t('requis.alphabeticOnly'),
                              },
                            ],
                          },
                        ]"
                      />
                    </a-form-item>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <legend>{{ $t("personnel.autre") }}:</legend>
                <div class="row">
                  <a-form-item :label="$t('profil.notes')" class="col-md-12">
                    <a-input
                      :placeholder="$t('profil.notes')"
                      type="textarea"
                      v-decorator="[
                        'notes',
                        {
                          initialValue: updateData.notes,
                        },
                      ]"
                    />
                  </a-form-item>
                </div>
              </fieldset>
              <div class="form-actions mt-0 row">
                <div class="col-md-2 offset-md-8 p-0">
                  <a-button key="back" @click="handleCancel">{{
                    $t("action.annuler")
                  }}</a-button>
                </div>
                <div class="col-md-2 p-0">
                  <a-button type="primary" htmlType="submit">{{
                    $t("action.modifier")
                  }}</a-button>
                </div>
              </div>
            </a-form>
          </a-modal>
        </div>
      </div>
      <div class="row my-3">
        <div class="col-lg-2">
          <span class="text-muted">
            <i class="fa fa-briefcase text-success pr-1"></i>
            :
            {{ $t("menu.enseignants") }}
          </span>
        </div>
        <div class="col-lg-2">
          <span class="text-muted">
            <i class="fa fa-suitcase text-warning pr-1" />
            :
            {{ $t("personnel.staff") }}
          </span>
        </div>
      </div>
      <div>
        <a-table
          :pagination="true"
          :data-source="data"
          :loading="tableLoading"
          :columns="columns"
          rowKey="_id"
          :scroll="{ x: 'max-content' }"
        >
          <template slot="StartDate" slot-scope="text, record">{{
            moment(record.StartDate).format("DD/MM/YYYY")
          }}</template>
          <template slot="endDate" slot-scope="text, record">
            {{
              record.endDate
                ? moment(record.endDate).format("DD/MM/YYYY")
                : $t("inscription.notSpecified")
            }}
          </template>
          <template slot="operation" slot-scope="text, record">
            <div class="editable-row-operations">
              <span v-if="record.editable">
                <a @click="() => save(record.key)">{{ $t("all.save") }}</a>
                <a-popconfirm
                  :title="$t('inscription.sureToCancel')"
                  @confirm="() => cancel(record.key)"
                >
                  <a>{{ $t("action.annuler") }}</a>
                </a-popconfirm>
              </span>
              <span v-else>
                <a-button
                  type="primary"
                  :disabled="editingKey !== ''"
                  @click="() => edit(record)"
                >
                  <a-icon
                    type="edit"
                    :disabled="editingKey !== ''"
                    @click="() => edit(record)"
                  />
                  {{ $t("action.modifier") }}
                </a-button>
              </span>
            </div>
          </template>
          <div
            slot="filterDropdown"
            slot-scope="{
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }"
            style="padding: 8px"
          >
            <a-input
              v-ant-ref="(c) => (searchInput = c)"
              :placeholder="$t('paiement.chercher') + ` ${column.title}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block"
              @change="
                (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
              "
              @pressEnter="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
              >{{ $t("paiement.chercher") }}</a-button
            >
            <a-button
              size="small"
              style="width: 90px"
              @click="() => handleReset(clearFilters)"
              >{{ $t("action.reinitialiser") }}</a-button
            >
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <template
            slot="customRender"
            slot-scope="text, record, index, column"
          >
            <span v-if="searchText && searchedColumn === column.dataIndex">
              <template
                v-for="(fragment, i) in text
                  .toString()
                  .split(
                    new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                  )"
              >
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
                  >{{ fragment }}</mark
                >
                <template v-else>{{ fragment }}</template>
              </template>
            </span>
            <template v-else>{{ text }}</template>
          </template>
          <template slot="delete" slot-scope="text, record">
            <a-popconfirm
              :title="$t('inscription.sureToDelete')"
              :okText="$t('all.oui')"
              :cancelText="$t('all.cancel')"
              @confirm="() => onDelete(record.key)"
            >
              <a-button type="danger">
                <a-icon type="delete" href="javascript:;" />
                {{ $t("action.supprimer") }}
              </a-button>
            </a-popconfirm>
          </template>
          <template slot="isTeacher" slot-scope="text, record">
            <i v-if="record.isA_Teacher" class="fa fa-briefcase text-success" />
            <i v-else class="fa fa-suitcase text-warning" />
          </template>
          <template
            slot="middleName"
            slot-scope="text, record, index, column"
          >
            <span v-if="searchText && searchedColumn === column.dataIndex">
              <template
                v-for="(fragment, i) in String(text == null ? '' : text)
                  .split(
                    new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                  )"
              >
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
                  >{{ fragment }}</mark
                >
                <template v-else>{{ fragment }}</template>
              </template>
            </span>
            <template v-else>{{ text || "" }}</template>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import $ from "jquery";
import apiClient from "@/services/axios";
import JsPDF from "jspdf";
import "jspdf-autotable";
import writtenNumber from "written-number";
import { mapState } from "vuex";
import moment from "moment";
import { pdfHeader } from "@/utilities/pdfUtils";
import { isKenyanSchool } from "@/utilities/countrySpecific";
import { KENYAN_BANKS } from "@/config/KenyanBanks";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export default {
  computed:{
     ...mapState(["settings"]),
     isKenyan() {
       return isKenyanSchool();
     },
  columns() {
    return [
        {
          title: "",
          dataIndex: "isTeacher",
          scopedSlots: { customRender: "isTeacher" },
          fixed: "left",
        },
        {
          title: this.$t("personnel.prenom"),
          dataIndex: "firstName",
          key: "firstName",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "firstName",
          },
          onFilter: (value, record) =>
            record.firstName.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("profil.middleName"),
          dataIndex: "middleName",
          key: "middleName",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "middleName",
          },
          onFilter: (value, record) =>
            (record.middleName || "")
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("personnel.nom"),
          dataIndex: "lastName",
          key: "lastName",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "lastName",
          },
          onFilter: (value, record) =>
            record.lastName.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("personnel.adresse"),
          dataIndex: "adress",
          key: "adress",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "adress",
          },
          onFilter: (value, record) =>
            record.adress.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("personnel.telephone"),
          dataIndex: "phone",
          key: "phone",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "phone",
          },
          onFilter: (value, record) =>
            record.phone.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("personnel.qualification"),
          dataIndex: "position.name",
          key: "qualification",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "qualification",
          },
          onFilter: (value, record) =>
            record.qualification.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("all.startDate"),
          dataIndex: "StartDate",
          key: "StartDate",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "StartDate",
          },
          onFilter: (value, record) =>
            record.StartDate.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("all.endDate"),
          dataIndex: "endDate",
          key: "endDate",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "endDate",
          },
          onFilter: (value, record) =>
            record.endDate.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("personnel.typeContrat"),
          dataIndex: "contract",
          key: "contract",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "contract",
          },
          onFilter: (value, record) =>
            record.contract.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("personnel.salaire"),
          dataIndex: "salary.net",
          key: "salary",
          width: "auto",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "salary",
          },
          onFilter: (value, record) =>
            record.salary.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("action.modifier"),
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
          fixed: "right",
        },
        {
          title: this.$t("action.supprimer"),
          dataIndex: "delete",
          scopedSlots: { customRender: "delete" },
          fixed: "right",
        },
      ]}
     },
  data() {
    return {
      positionsList: [],
      dateFormat: "DD/MM/YYYY",
      editingKey: "",
      loadingAddBtn: false,
      tableLoading: false,
      visibleParentFile: false,
      data: [],
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      targetKeys: [],
      previewVisible: false,
      previewImage: "",
      form: this.$form.createForm(this),
      updateForm: this.$form.createForm(this),
      kenyanBanks: KENYAN_BANKS,
      updateData: {
        _id: "",
        firstName: "",
        middleName: "",
        lastName: "",
        birthDate: "",
        cin: "",
        adress: "",
        phone: 0,
        civilStatus: "",
        level: "",
        experiences: "",
        position: { _id: "" },
        contract: "",
        salary: { net: 0 },
        isA_Teacher: false,
        interviewDate: "",
        StartDate: "",
        endDate: "",
        hourlyRate: 0,
        dayOfWeek: 0,
        expectedHoursPerDay: null,
        daysOff: [],
        CNSS: 0,
        RIB: 0,
        PIN: "",
        SHA: "",
        NSSF: "",
        bankAccountNo: "",
        bankName: "",
        bankBranch: "",
        notes: "",
      },
      value: 1,
      value1: 1,
      loadingPersonnel: false,
      visibleData: false,
      visibleUpdateData: false,
    }
  },
  async created() {
    this.tableLoading = true;
    await apiClient
      .post("/employees/filter", {
        status: "active",
      })
      .then((res) => {
        this.data = res.data.map((elem) => ({ ...elem, key: elem._id }));
      })
      .catch(() => this.$message.error("Aucun Personnel est trouvé"));
    this.cacheData = this.data.map((item) => ({ ...item }));
    apiClient
      .post("/positions/filter", { query: { status: "active" } })
      .then((res) => (this.positionsList = res.data))
      .catch(() => {});
    this.tableLoading = false;
  },
  methods: {
    moment,
    updatePersonnel(e) {
      e.preventDefault();
      this.updateForm.validateFieldsAndScroll((err, values) => {
        if (err) {
          return;
        }

        // --- Phone validation for TN/KE ---
        const phone = (values.phone || "").trim();
        if (phone) {
          const digits = phone.replace(/\D/g, "");
          if (phone.startsWith("+216") && digits.length !== 11) {
            this.$message.error(this.$t('requis.telephone'));
            return;
          }
          if (phone.startsWith("+254") && digits.length !== 13) {
            this.$message.error(this.$t('requis.telephoneKE'));
            return;
          }
        }
        // --- End phone validation ---

        const id = this.updateData._id;
        if (this.isKenyan) {
          if (values.bankName === undefined || values.bankName === null) {
            values.bankName = '';
          }
          if (values.bankBranch === undefined || values.bankBranch === null) {
            values.bankBranch = '';
          }
        }
        apiClient
          .patch(`/employees/${id}`, values)
          .then((res) => {
            this.data = this.data.map((elem) =>
              elem._id == id
                ? {
                    ...values,
                    _id: id,
                    position: { _id: values.position },
                    isA_Teacher: elem.isA_Teacher,
                  }
                : elem
            );
            this.$message.success(this.$t("success.personnelMSA"));
            this.updateForm.resetFields();
            this.visibleUpdateData = false;
          })
          .catch((e) =>
            this.$message.error(e?.response?.data?.errorCode ? this.$t(`errorCode.${e.response.data.errorCode}`) : this.$t("error.personnelNonMSA"))
          );
      });
    },
    handleChange(value, key, column) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.data = newData;
      }
    },
    edit(record) {
      this.updateData = record;
      this.visibleUpdateData = true;
    },
    save(key) {
      const newData = [...this.data];
      const newCacheData = [...this.cacheData];
      const target = newData.filter((item) => key === item.key)[0];
      const targetCache = newCacheData.filter((item) => key === item.key)[0];
      if (target && targetCache) {
        delete target.editable;
        this.data = newData;
        Object.assign(targetCache, target);
        this.cacheData = newCacheData;
      }
      this.editingKey = "";
    },
    cancel(key) {
      const newData = [...this.data];
      const target = newData.filter((item) => key === item.key)[0];
      this.editingKey = "";
      if (target) {
        Object.assign(
          target,
          this.cacheData.filter((item) => key === item.key)[0]
        );
        delete target.editable;
        this.data = newData;
      }
    },
    onDelete(key) {
      apiClient
        .patch("/employees/" + key, {
          status: "inactive",
        })
        .then(() => {
          this.$message.success(this.$t("success.personnelSupp"));
          const dataSource = [...this.data];
          this.data = dataSource.filter((item) => item.key !== key);
        })
        .catch(() =>
          this.$message.success(this.$t("success.personnelNonSupp"))
        );
    },
    addPersonnel(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        if (err) {
          return;
        }

        // --- Phone validation for TN/KE ---
        const phone = (values.phone || "").trim();
        if (phone) {
          const digits = phone.replace(/\D/g, "");
          if (phone.startsWith("+216") && digits.length !== 11) {
            this.$message.error(this.$t('requis.telephone'));
            return;
          }
          if (phone.startsWith("+254") && digits.length !== 13) {
            this.$message.error(this.$t('requis.telephoneKE'));
            return;
          }
        }
        // --- End phone validation ---

        this.loadingAddBtn = true;
        if (this.isKenyan) {
          if (values.bankName === undefined || values.bankName === null) {
            values.bankName = '';
          }
          if (values.bankBranch === undefined || values.bankBranch === null) {
            values.bankBranch = '';
          }
        }
        apiClient
          .put("/employees", values)
          .then((res) => {
            this.data.push({ ...res.data, key: res.data._id });
            this.$message.success(this.$t("success.personnelAjout"));
            this.handleCancel();
          })
          .catch((e) =>{
            const errorCode = e?.response?.data?.errorCode? "errorCode."+e.response.data.errorCode : "";
            this.$message.error(this.$t(errorCode) || this.$t("error.personnelNonAjoute"))
          })
          .finally(() => (this.loadingAddBtn = false));
      });
    },
    handleCancel(e = null) {
      this.form.resetFields();
      this.updateForm.resetFields();
      this.visibleData = false;
      this.visibleUpdateData = false;
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    getMock() {
      const targetKeys = [];
      const mockData = [];
      for (let i = 0; i < 20; i++) {
        const data = {
          key: i.toString(),
          title: `content${i + 1}`,
          description: `description of content${i + 1}`,
          chosen: Math.random() * 2 > 1,
        };
        if (data.chosen) {
          targetKeys.push(data.key);
        }
        mockData.push(data);
      }
      this.mockData = mockData;
      this.targetKeys = targetKeys;
    },
    generatePdf() {
      this.$gtag.event("Imp Liste des personnels", {
        event_category: "Impression PDF",
        event_label: "Personnel - ListePersonnels section",
        value: 1,
      });

      const isArabic = this.$i18n.locale === 'ar-AR';

      // Helper function to reverse array if Arabic
      const reverseIfArabic = (arr) => isArabic ? arr.slice().reverse() : arr;

      const doc = pdfHeader(this.settings, {
        title: this.$t("personnel.personalList"),
        locale: this.$i18n.locale
      });
      var arr = [];
      const array = [];
      var counter = 1;
      let somme = 0;
      for (let i = 0; i < this.data.length; i++) {
        arr.push(counter);
        // arr.push(this.data[i].matricule);
        arr.push(
          this.data[i].firstName +
            (this.data[i].middleName ? " " + this.data[i].middleName : "") +
            " " +
            this.data[i].lastName
        );
        const salaryValue =
          this.data[i].salary && this.data[i].salary.net
            ? this.data[i].salary.net
            : "--";
        arr.push(salaryValue);
        arr.push(
          this.data[i].position && this.data[i].position.name
            ? this.data[i].position.name
            : "--"
        );
        arr.push(this.data[i].contract);
        arr.push(this.data[i].phone);

        // Reverse for Arabic if needed
        if (isArabic) {
          arr.reverse();
        }

        somme += salaryValue !== "--" ? parseFloat(salaryValue) : 0;
        array.push(arr);
        arr = [];
        counter++;
      }
      doc.autoTable({
        theme: "grid",
        styles: { font: "Amiri", halign: isArabic ? "right" : "left" },
        headStyles: { halign: isArabic ? "right" : "left" },
        bodyStyles: { halign: isArabic ? "right" : "left" },
        startY: 45,
        head: [
          reverseIfArabic([
            this.$t("paiement.num"),
            this.$t("inscription.nom"),
            this.$t("personnel.salaire"),
            this.$t("personnel.qualification"),
            this.$t("etablissement.type"),
            this.$t("personnel.telephone"),
          ])
        ],
        body: array,
        foot: [
          reverseIfArabic([
            this.$t("personnel.totalSalary") + ":",
            {
              colSpan: 4,
              content:
                writtenNumber(somme, {
                  lang: this.$i18n.locale.split("-")[0],
                }) + " DT",
              styles: { halign: "center" },
            },
            somme,
          ])
        ],
      });

      doc.save(this.$t("personnel.listPersonnelPDF") + ".pdf");
    },
    showModal() {
      this.visibleData = true;
    },
    onChange(e) {},
    onChangeParent(e) {},
    handleCancelImage() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChangeSelect(value) {},
    handleBlur() {},
    handleFocus() {},
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>
<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.editable-row-operations a {
  margin-right: 8px;
}
.switch {
  float: right;
  margin-right: 15px;
}
.bottom {
  margin-top: 7px;
}
label {
  width: 300px;
  line-height: 26px;
  margin-bottom: 20px;
}

a-input {
  height: 25px;
  width: 50%;
  margin-left: 50px;
}
.span {
  /* display: flex;  */
  flex-direction: row;
}
.space {
  margin-left: 200px;
}
.inp {
  margin-left: 0px;
}
.clearfix {
  float: right;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
